/* eslint-disable */
import { BiBot, BiLineChart } from "react-icons/bi";
import { BsCodeSlash, BsLightningCharge } from "react-icons/bs";
import { FaChalkboardTeacher, FaProjectDiagram } from "react-icons/fa";
import { HiOutlineUserGroup } from "react-icons/hi";
import { MdOutlineSettingsSuggest } from "react-icons/md";

 

export const servicesData = [
    {
        id: 1,
        title: 'AI Solutions & MCP Integration',
        icon: <BiBot />
    },
    {
        id: 2,
        title: 'System Architecture & Scalability',
        icon: <FaProjectDiagram />
    },
    {
        id: 3,
        title: 'Technical Leadership & Mentoring',
        icon: <HiOutlineUserGroup />
    },
    {
        id: 4,
        title: 'Full Stack Development',
        icon: <BsCodeSlash />
    },
    {
        id: 5,
        title: 'E-commerce & Integration Strategy',
        icon: <BiLineChart />
    },
    {
        id: 6,
        title: 'Performance Optimization',
        icon: <BsLightningCharge />
    },
    {
        id: 7,
        title: 'Infrastructure & Cloud Strategy',
        icon: <MdOutlineSettingsSuggest />
    },
    {
        id: 8,
        title: 'Technical Writing & Training',
        icon: <FaChalkboardTeacher />
    },
]


// Uncomment your required service.
// Couldn't find the required services? Raise an issue on github at https://github.com/praveenmistry/developer-portfolio/issues/new
// You can also add on your own 😉.